<div class="field mb-2 w-full" [ngClass]="options.containerClass">
  <ng-container *ngIf="customFormGroup; else elseTemplate">
    <ng-container [formGroup]="customFormGroup">
      <label *ngIf="options.label">{{ options.label | translate }}</label>
      <div class="inputgroup flex relative">
        <input
          class="w-full"
          [type]="isPassShown ? 'text' : 'password'"
          pInputText
          [formControlName]="options.formControlName"
          (input)="onChange($event)"
        />
        <span
          (click)="togglePassShow()"
          class="absolute cursor-pointer"
          style="right: 0.6rem; transform: translate(0%, 50%)"
          ><i [class]="isPassShown ? 'pi pi-eye' : 'pi pi-eye-slash'"></i
        ></span>
      </div>
    </ng-container>
  </ng-container>
  <ng-template #elseTemplate>
    <label *ngIf="options.label">{{ options.label | translate }}</label>
    <div class="inputgroup flex relative">
      <input
        class="w-full"
        [type]="isPassShown ? 'text' : 'password'"
        pInputText
        [formControlName]="options.formControlName"
        (input)="onChange($event)"
      />
      <span
        (click)="togglePassShow()"
        class="absolute cursor-pointer"
        style="right: 0.6rem; transform: translate(0%, 50%)"
        ><i [class]="isPassShown ? 'pi pi-eye' : 'pi pi-eye-slash'"></i
      ></span>
    </div>
  </ng-template>

  <app-field-errors [errors]="errors"></app-field-errors>
</div>
